// TEMPORARY: hardcoded AI pill trending searches. Remove with assets/trending_chips when reverting.
import { translate } from '@fiverr-private/i18n-react';
import wixIcon from '../../assets/trending_chips/wix.svg';
import squarespaceIcon from '../../assets/trending_chips/squarespace.svg';
import aiMovieTrailerIcon from '../../assets/trending_chips/ai_movie_trailer.svg';
import quickbooksIcon from '../../assets/trending_chips/quickbooks.svg';
import voiceOverIcon from '../../assets/trending_chips/voice_over.svg';
import youtubeIcon from '../../assets/trending_chips/youtube.svg';

const COPY_PREFIX = 'search_bar.ai_pill.trending_searches';

export const HARDCODED_TRENDING = [
    { copyKey: `${COPY_PREFIX}.wix_website_redesign`, icon: wixIcon, subCategoryId: 151 }, // Website Design
    { copyKey: `${COPY_PREFIX}.build_squarespace_website`, icon: squarespaceIcon, subCategoryId: 514 }, // Website Development
    { copyKey: `${COPY_PREFIX}.ai_movie_trailer`, icon: aiMovieTrailerIcon, subCategoryId: 562 }, // Video Art Creation
    { copyKey: `${COPY_PREFIX}.quickbooks_clean_up`, icon: quickbooksIcon, subCategoryId: 617 }, // Accounting
    { copyKey: `${COPY_PREFIX}.female_voice_over`, icon: voiceOverIcon, subCategoryId: 16 }, // Voice Over
    { copyKey: `${COPY_PREFIX}.youtube_channel_monetization`, icon: youtubeIcon, subCategoryId: 69 }, // Video Marketing
];

export const SUB_CATEGORY_QUERIES = Object.fromEntries(
    HARDCODED_TRENDING.map(({ subCategoryId, copyKey }) => [subCategoryId, copyKey])
);

export const getHardcodedTrending = (locale) =>
    HARDCODED_TRENDING.map(({ copyKey, icon }) => ({ value: translate(copyKey, { locale }), icon }));
